import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { loadAndAssert } from '../authz/access.js';
import { Submission } from '../submission.js';

export const deleteSubmissionMutation = registerMutation({
  operationName: 'deleteSubmissionMutation',
  type: () => Boolean,
  params: [{ name: 'submissionId', type: () => String }],
  resolve: (submissionId: string) => async () => {
    await loadAndAssert(Submission, submissionId, 'delete', { _id: 1 });

    // Takes its files and the results released from it with it (see delete-cascade.ts). Imported here: this module
    // also reaches the client bundle (chat.tsx), the cascade is server only.
    const { deleteSubmissionCascade } = await import('../utils/delete-cascade.js');
    await deleteSubmissionCascade(submissionId);

    return true;
  },
});
